import { FC, useContext } from "react"
import { Controller } from "react-hook-form"
import Select from "react-select"
import { Col, Input, Label, Row } from "reactstrap"
import { AppContext } from "../../../../../context"
import { CommissionOverwriteFormProps } from "../../../../../interfaces"
import { customSelectStyleNew } from "../../../../styled/customSelect"

const CommissionOverwriteForm: FC<CommissionOverwriteFormProps> = ({ getValues, control, errors, commissionOverwrite }) => {
  const { theme } = useContext(AppContext)

  return <Row className="my-4 fs-14" >
    <Col sm='8' className="mb-3">
      <Label className="text-14 text-blackele pb-2">Overwrite Type <span className="text-danger">*</span></Label>
      <Controller
        name="type"
        defaultValue={commissionOverwrite?.type ? { value: commissionOverwrite?.type.toUpperCase(), label: commissionOverwrite?.type } : null}
        rules={{ required: { value: true, message: "Overwrite Type is a required field" } }}
        control={control}
        render={({ field: { onChange, value } }) => (
          <Select
            value={value}
            options={[{ value: "REFERRAL", label: "Referral" }, { value: "TEAM", label: "Team" }]}
            onChange={(val) => onChange(val)}
            styles={{ ...customSelectStyleNew(theme) }}
            placeholder="Select Type"
          />
        )}
      />
      <small className="text-danger pt-2">
        {errors?.type?.message as any}
      </small>
    </Col>

    <Col sm='6' className="mb-3 custom-form-input form-input">
      <Label className="text-14 text-blackele pb-2">Valid Days {
        getValues().type?.value === 'REFERRAL' && <span className="text-danger">*</span>} </Label>
      <Controller
        name="validDays"
        defaultValue={commissionOverwrite?.validDays}
        rules={{ required: { value: getValues().type?.value === 'REFERRAL', message: "Valid Days is a required field" } }}
        control={control}
        render={({ field }) => (
          <Input
            value={field.value ?? ''}
            placeholder="Valid Days"
            type="text"
            onChange={({ target: { value } }) => {
              const filteredValue = value.replace(/,/g, '').replace(/\D/g, "")
              field.onChange(filteredValue.slice(0, 3))
            }}
            onFocus={(e) => e.target.value && field.onChange(e.target.value.replaceAll(" days", ""))}
            onBlur={(e) => {
              if (e.target.value) field.onChange(e.target.value + " days");
              field.onBlur();
            }}
            ref={field.ref}
          />
        )}
      />
      <small className="text-danger pt-2">
        {errors?.validDays?.message as any}
      </small>
    </Col>

    <Col sm='6' className="mb-3 custom-form-input form-input">
      <Label className="text-14 text-blackele pb-2">Overwrite Percentage <span className="text-danger">*</span></Label>
      <Controller
        name="percentage"
        defaultValue={commissionOverwrite?.percentage?.replaceAll(" ", "")}
        rules={{ required: { value: true, message: "Overwrite Percentage is a required field" } }}
        control={control}
        render={({ field }) => (
          <Input
            value={field.value ?? ''}
            placeholder="Overwrite Percentage"
            type="text"
            onChange={({ target: { value } }) => {
              const filteredValue = value.replace(/,/g, '').replace(/[^\d.]/g, "").replace(/^\./, "0.")
              field.onChange(filteredValue.slice(0, 4))
            }}
            onFocus={(e) => e.target.value && field.onChange(e.target.value.replaceAll("%", "").replaceAll(" ", ""))}
            onBlur={(e) => {
              if (e.target.value) field.onChange(e.target.value + "%");
              field.onBlur();
            }}
            ref={field.ref}
          />
        )}
      />
      <small className="text-danger pt-2">
        {errors?.percentage?.message as any}
      </small>
    </Col>

    <Col sm='12' className="mb-3 custom-form-input form-input">
      <Label className="text-14 text-blackele pb-2">Note <span className="text-danger">*</span></Label>
      <Controller
        name="note"
        rules={{ required: { value: true, message: "Note is a required field" } }}
        control={control}
        render={({ field }) => (
          <Input
            value={field.value ?? ''}
            onChange={(e) => field.onChange(e.target.value)}
            onBlur={field.onBlur}
            ref={field.ref}
            placeholder="Enter note"
            type="text"
          />
        )}
      />
      <small className="text-danger pt-2">
        {errors?.note?.message as any}
      </small>
    </Col>

  </Row >
}
export default CommissionOverwriteForm